import Button from '@/common/Button';
import { InputWithIcon } from '@/components/Input';
import QueryFilters from '@/components/QueryFilters';
import Select from '@/common/Select';
import TrainingPageNavigationDropdown from '@/features/Settings/components/TrainingPageNavigationDropdown';
import { onEnter } from '@/utils';
import { useMemo } from 'react';
import { useQuestionsState } from '@/features/Settings/pages/Questions';

const QuestionFilters = (): JSX.Element => {
  const [{ text, categoryId, roleId, categories, fetch, onReset }, setState] = useQuestionsState(({ state, setState }) => [
    {
      text: state.filters.text,
      categoryId: state.filters.categoryId,
      roleId: state.filters.roleId,
      categories: state.categories,
      fetch: state.fetch,
      onReset: state.onReset,
    },
    setState,
  ]);

  const categoriesForActiveRole = useMemo(() => categories.filter((category) => category.roleId === roleId), [categories, roleId]);

  const handleChangeText = (value: string): void => setState((current) => ({ ...current, filters: { ...current.filters, text: value } }));
  const handleChangeCategory = (value: string): void =>
    setState((current) => ({ ...current, filters: { ...current.filters, categoryId: value || undefined } }));

  return (
    <QueryFilters className="QuestionFilters justify-content-between">
      <div className="d-flex gap-2">
        <QueryFilters.Control>
          <Select value={categoryId || ''} onChange={handleChangeCategory} placeholder="All Categories">
            {[{ id: '', name: 'All Categories' }, ...categoriesForActiveRole].map((category) => (
              <Select.Option key={category.id || 'all'} value={category.id}>
                {category.name}
              </Select.Option>
            ))}
          </Select>
        </QueryFilters.Control>
        <QueryFilters.Control>
          <InputWithIcon
            icon={<i className="sv sv-magnifier fs-4" />}
            name="text"
            value={text || ''}
            onChange={handleChangeText}
            onKeyDown={onEnter(fetch)}
            placeholder="Search"
          />
        </QueryFilters.Control>
        <QueryFilters.Control>
          <Button name="SUBMIT_SEARCH" variant="success" className="border-white" onClick={fetch}>
            GO
          </Button>
          <Button name="RESET_SEARCH" variant="outline-light" onClick={onReset}>
            Reset
          </Button>
        </QueryFilters.Control>
      </div>
      <div className="d-flex gap-2">
        <QueryFilters.Input>
          <TrainingPageNavigationDropdown />
        </QueryFilters.Input>
      </div>
    </QueryFilters>
  );
};

export default QuestionFilters;
